module.exports = __webpack_public_path__ + "img/E4.6b067813.png";